import React from 'react';
import { uploadToS3, uploadToken } from '../services/interviewService';

interface IProps {
  event: React.ChangeEvent<HTMLInputElement>;
  fieldName: string,
  onSuccess: (filename: string, url:string) => void;
  onProgress: (progress: any) => void;
  onError: () => void;
  onDone: () => void;
}
export const uploadFile = async ({
  event, fieldName, onSuccess, onProgress, onError, onDone,
}: IProps) => {
  if (!event.target.files) return;
  const file = event.target.files[0];
  try {
    const { data } = await uploadToken(`${fieldName}--${file.name.replaceAll('--', '_')}`, file.type);
    await uploadToS3(data.url, file, (e) => { onProgress(e); });
    const imageUrl = data.url.split('?')[0];
    onSuccess(file.name, imageUrl);
  } catch (err) {
    onError();
  } finally {
    onDone();
  }
};
